import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress-img',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponentImg implements OnInit {
  @Input() progress = 0;
  constructor() {}

  ngOnInit() {}
}
